import { cn } from '@/lib/cn'

export type IconSize = 14 | 15 | 16 | 17 | 18 | 19 | 20 | 22 | 24 | 28

export interface IconProps {
  /** Material Symbols Rounded ligature name, e.g. "account_balance". */
  readonly name: string
  readonly size?: IconSize | undefined
  readonly filled?: boolean | undefined
  readonly className?: string | undefined
  readonly label?: string | undefined
}

export function Icon({ name, size = 18, filled = false, className, label }: IconProps) {
  return (
    <span
      className={cn('pb-icon', className)}
      style={{
        fontSize: `${size}px`,
        width: `${size}px`,
        height: `${size}px`,
        fontVariationSettings: `'FILL' ${filled ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' ${size}`,
      }}
      aria-hidden={label ? undefined : true}
      role={label ? 'img' : undefined}
      aria-label={label}
    >
      {name}
    </span>
  )
}
